import { hToggleArrayItem } from '@/utils/helpers';
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShStarRating from '@/components/Helpers/ShStarRating';
import ShButton from '@/components/Helpers/ShButton';
import DepartmentNameAndSymbolForm from '@/components/Departments/DepartmentNameAndSymbolForm';
import DepartmentAssignedAgentsForm from '@/components/Departments/DepartmentAssignedAgentsForm';

// @vue/component
export default {
  name: 'CreateDepartmentForm',

  components: {
    ShUserAvatar,
    ShStarRating,
    ShButton,
    DepartmentNameAndSymbolForm,
    DepartmentAssignedAgentsForm,
  },

  props: {
    agentsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      newDepartment: {},
      selectedAgents: [],
      errorMessage: null,
    };
  },

  computed: {
    agentsFeedbackList() {
      return this.$store.getters['agents/feedbacksList'];
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'departments/create',
      ]);
    },
  },

  created() {
    this.$store.dispatch('agents/getFeedbackList');
  },

  methods: {
    handleUpdateNewDepartmentData(department) {
      this.errorMessage = null;
      this.newDepartment = {
        ...this.newDepartment,
        ...department,
      };
    },
    handleUpdateAgentsAssigment(agentId) {
      this.selectedAgents = hToggleArrayItem(this.selectedAgents, agentId);
      this.handleUpdateNewDepartmentData({
        assignedAgents: this.selectedAgents,
      });
    },
    async handleCreateNewDepartment() {
      if (!this.__validateNewDepartmentData()) {
        return;
      }
      await this.$store.dispatch('departments/create', this.newDepartment);
      this.$store.dispatch('departments/getList');
      this.$notify.success({
        title: 'Nowy Wirtualny Dział',
        message: `Utworzono Wirtualny Dział - ${this.newDepartment.name}`,
        customClass: 'callmeweb-notification',
      });
      this.$emit('closeModal');
    },
    __validateNewDepartmentData() {
      if (!this.newDepartment.name) {
        this.errorMessage = 'Nadaj proszę nazwę nowego Wirtualnego Działu';
        return false;
      }

      return true;
    },
  },
};
